import { StrictMode } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { STATIC_HOME_CRAWL_ID } from "@/lib/static-home-crawl";

console.info("FabChat app build: ptt-ogg-only-2026-06-03");

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("Elemento #root não encontrado");
}

const isSSR = rootEl.hasAttribute("data-ssr");

const docRoot = document.documentElement;
const storedTheme =
  typeof localStorage?.getItem === "function"
    ? localStorage.getItem("theme") || "system"
    : "system";

if (storedTheme === "system") {
  const systemTheme = window.matchMedia("(prefers-color-scheme: dark)").matches
    ? "dark"
    : "light";
  docRoot.classList.add(systemTheme);
} else {
  docRoot.classList.add(storedTheme);
}

const app = import.meta.env.DEV ? (
  <App />
) : (
  <StrictMode>
    <App />
  </StrictMode>
);

if (isSSR) {
  hydrateRoot(rootEl, app);
} else {
  createRoot(rootEl).render(app);
  document.getElementById("initial-loader")?.remove();
}

document.getElementById(STATIC_HOME_CRAWL_ID)?.remove();

if (!isSSR && "serviceWorker" in navigator) {
  const isInIframe = (() => {
    try {
      return window.self !== window.top;
    } catch {
      return true;
    }
  })();

  const host = window.location.hostname;
  const isPreviewHost =
    host.includes("lovableproject.com") ||
    (host.includes("lovable.app") && host.includes("id-preview--")) ||
    host.includes("id-preview--");

  const isLocalDev =
    host === "localhost" || host === "127.0.0.1" || host.endsWith(".localhost");

  if (isInIframe || isPreviewHost || isLocalDev) {
    navigator.serviceWorker.getRegistrations().then((regs) => {
      regs.forEach((r) => r.unregister().catch(() => {}));
    }).catch(() => {});
  } else {
    window.addEventListener("load", () => {
      navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch(() => {});
    });
  }
}
